import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Newsletter from "../components/newsletter"
import RassegnaStampa from "../components/rassegna-stampa"


const RassegnaStampaPage = ({pageContext: {locale}}) => {
  return (
    <Layout locale={locale}>
      <SEO title="rassegna-stampa" />
      <div className="event-wrapper">
        <RassegnaStampa />
        <Newsletter />
      </div>
    </Layout>
  );
}

export default RassegnaStampaPage;